;(function() {
  'use strict'

  Controller.$inject = ["$q", "$timeout", "glDialog", "geocodeService", "locationService", "distanceService", "glAnalytics"];
  angular.module('app.survey').component('surveyQuestionLocation', {
    controller: Controller,
    templateUrl: 'survey-question-location.html',
    bindings: {
      question: '=',
      survey: '=',
    },
  })

  /* @ngInject */
  function Controller(
    $q,
    $timeout,
    glDialog,
    geocodeService,
    locationService,
    distanceService,
    glAnalytics
  ) {
    var ctrl = this

    var currentRequest = 0
    var currentPlacesRequest = 0

    ctrl.States = {
      IDLE: 'idle',
      LOADING: 'loading',
      NONE: 'none',
      RESULTS: 'results',
      SKIP: 'skip',
    }
    ctrl.MeasurementSystems = distanceService.MeasurementSystems

    ctrl.onFieldClick = onFieldClick
    ctrl.onResultClick = onResultClick
    ctrl.search = _.debounce(search, 500)
    ctrl.select = select
    ctrl.useMyLocation = useMyLocation
    ctrl.searchPlaces = _.debounce(searchPlaces, 500)
    ctrl.selectPlace = selectPlace
    ctrl.toggleMeasurementSystem = toggleMeasurementSystem
    ctrl.onInputFocus = onInputFocus
    ctrl.onInputBlur = onInputBlur

    ctrl.$onInit = onInit

    function onInit() {
      // TODO: rebuild data from autocompleted question... or something
      if (!ctrl.question.data) {
        ctrl.question.data = {}
      }

      if (ctrl.question.locationType === ctrl.question.LocationTypes.PLACES) {
        ctrl.isPlacesType = true
        ctrl.excludePlaceIds = ctrl.question.locationExcludePrevious
          ? ctrl.survey.getPrevSelectedPlaceIds()
          : []
        ctrl.typesFilter = ctrl.question.locationTypesFilter.length
          ? ctrl.question.locationTypesFilter
          : [null]

        var placesQuery = ctrl.survey.injectValues(
          ctrl.question.locationSearchTermsPipes,
          ctrl.question.loopKey
        )
        if (
          ctrl.question.data.injectedPlacesQuery &&
          ctrl.question.data.injectedPlacesQuery === placesQuery
        ) {
          // resume the stored state ONLY if the query didnt change from pipes
          return
        }
        ctrl.question.data.injectedPlacesQuery = placesQuery
        ctrl.question.data.placesQuery = placesQuery
        ctrl.question.data.measurementSystem = distanceService.getUserMeasurementSystem()

        initPlaces()
      }
    }

    function onFieldClick() {
      // if something is selected, reset and focus input
      if (ctrl.question.data.selected) {
        select(null)
      }
    }

    function onResultClick(locality) {
      setResults(null)
      select(locality)
      ctrl.question.data.query = null
    }

    function search() {
      var query = ctrl.question.data.query
      var thisRequest = ++currentRequest

      select(null)
      setResults(null)

      if (!query) {
        return
      }

      ctrl.state = ctrl.States.LOADING

      // HACK: For some reason "Sydney" has no results even though
      // other terms like "Melbourne" do.
      // If the user enters Sydney we'll append "NSW" behind the scenes
      // so that they get results.
      if (query.toLowerCase() === 'sydney') {
        query += ' NSW'
      }

      track('search', { query: query })
      geocodeService
        .findLocalities(
          query,
          ctrl.question.locationBiasCountryCode,
          ctrl.question.locationRestrictCountryCode
        )
        .then(function(localities) {
          if (currentRequest !== thisRequest) {
            return
          }
          setResults(localities)
        })
    }

    function track(action, label) {
      label = _.isPlainObject(label) ? label : {}
      label.surveyId = ctrl.survey.id
      label.questionId = ctrl.question.id
      glAnalytics.track('survey-question-location', action, label)
    }

    function select(locality) {
      // if none or same, remove the selection
      if (!locality || ctrl.question.data.selected === locality) {
        ctrl.question.data.selected = null
        if (ctrl.isPlacesType) {
          // if places type, don't clear the text answer
          return
        }
        ctrl.question.setLocationAnswer(null)

        // otherwise set the selection
      } else {
        ctrl.question.data.selected = locality
        if (ctrl.isPlacesType) {
          // if places type, trigger search places
          ctrl.question.data.placesLocality = locality
          return searchPlaces()
        }
        ctrl.question.setLocationAnswer(locality)
      }
    }

    function useMyLocation(e) {
      e.stopPropagation()

      ctrl.question.data.query = null
      select(null)
      setResults(null)

      ctrl.state = ctrl.States.LOADING

      locationService
        .get(true)
        .then(function(location) {
          var coords = location.position.coords

          track('useMyLocation')
          geocodeService
            .localitiesFromLocation(coords.latitude, coords.longitude)
            .then(function(localities) {
              setResults(localities)
            })
        })
        .catch(function() {
          ctrl.state = ctrl.States.IDLE
          glDialog.alert(
            'Location Disabled',
            'It looks like your browser is blocking location services. Please enable them and try again.'
          )
        })
    }

    function setResults(localities) {
      var data = ctrl.question.data
      data.results = localities
      // console.log('setResults', localities);

      if (!data.results) {
        ctrl.state = ctrl.States.IDLE
      } else if (_.isArray(data.results) && !data.results.length) {
        ctrl.state = ctrl.States.NONE
      } else if (_.isArray(data.results) && data.results.length) {
        ctrl.state = ctrl.States.RESULTS
      }
    }

    function initPlaces() {
      selectPlace(null)

      ctrl.isLoading = true
      locationService
        .get(true, true)
        .then(function(location) {
          var coords = location.position.coords

          track('initPlaces')
          geocodeService
            .getLocalityFromLocation(coords.latitude, coords.longitude)
            .then(function(locality) {
              if (locality) {
                var localityComponents = [locality.suburb, locality.state]
                locality.name = _.pull(localityComponents, undefined).join(', ')
                locality.lat = coords.latitude
                locality.lng = coords.longitude
                select(locality)
              }
              ctrl.isLoading = false
            })
        })
        .catch(function() {
          ctrl.isLoading = false
        })
    }

    function searchPlaces() {
      selectPlace(null)

      var data = ctrl.question.data
      data.placesState = ctrl.States.LOADING
      data.showMore = false
      data.allowLocationToPass = false
      data.placesResults = null

      var locality = data.placesLocality
      var query = data.placesQuery
      var thisRequest = ++currentPlacesRequest

      track('searchPlaces', {
        query: query,
        types: _.without(ctrl.typesFilter, null).join(', '),
      })
      var promises = _.map(ctrl.typesFilter, function(type) {
        return geocodeService.searchNearbyPlaces(
          locality.lat,
          locality.lng,
          query,
          type
        )
      })
      $q.all(promises)
        .then(function(promiseResults) {
          if (thisRequest !== currentPlacesRequest) {
            return
          }

          var results = _(promiseResults)
            .flatten()
            .filter(function(result) {
              return (
                !!result && !_.includes(ctrl.excludePlaceIds, result.place_id)
              )
            })
            .uniqBy('place_id')
            .value()

          if (!results || !results.length) {
            if (ctrl.question.locationShowSearchField) {
              data.placesState = ctrl.States.NONE
            } else {
              data.allowLocationToPass = true
              data.placesState = ctrl.States.SKIP
              ctrl.survey.applyTags([
                {
                  type: 'ADD',
                  tag: 'LOCATION_NO_RESULTS',
                  givenByViewIndex: -1,
                },
              ])
            }
          } else {
            data.placesResults = _.sortBy(results, 'distance')
              .slice(0, 20) // only show max 20 results
              .map(function(place) {
                place.distanceLabel = distanceService.metersToLabel(
                  place.distance,
                  ctrl.question.data.measurementSystem
                )
                return place
              })
            data.placesState = ctrl.States.RESULTS
          }
        })
        .catch(function() {
          // something wrong. ask respondent to retry
          data.placesState = ctrl.States.NONE
        })
    }

    function selectPlace(place) {
      // if none or same, remove the selection
      if (!place || ctrl.question.data.selectedPlace === place) {
        ctrl.question.data.selectedPlace = null
        ctrl.question.setLocationAnswer(null)

        // otherwise set the selection
      } else {
        ctrl.question.data.selectedPlace = place

        // Set the location answer with the locality (incomplete, will be fully populated later)
        ctrl.question.setLocationAnswer(place.locality)
      }
    }

    function toggleMeasurementSystem(measurementSystem) {
      if (ctrl.question.data.measurementSystem === measurementSystem) return
      ctrl.question.data.measurementSystem = measurementSystem
      _.each(ctrl.question.data.placesResults, function(place) {
        place.distanceLabel = distanceService.metersToLabel(
          place.distance,
          ctrl.question.data.measurementSystem
        )
      })
    }

    function onInputFocus(e) {
      if (!ctrl.isPlacesType) return

      // restore previous state
      if (ctrl.lastState) {
        ctrl.state = ctrl.lastState
      }
    }

    function onInputBlur(e) {
      if (!ctrl.isPlacesType) return

      // Add a one-time event listener for a click event
      document.addEventListener(
        'click',
        function(event) {
          // Get the field and results wrapper elements
          var field = angular.element(
            document.querySelector('.survey-question-location__field')
          )
          var resultsWrapper = angular.element(
            document.querySelector('.survey-question-location__results-wrapper')
          )
          // Return if the click is within the field or results wrapper
          if (
            field[0].contains(event.target) ||
            resultsWrapper[0].contains(event.target)
          ) {
            return
          }

          // Update the question data and state after a timeout
          $timeout(function() {
            if (
              !ctrl.question.data.selected &&
              ctrl.question.data.placesLocality
            ) {
              ctrl.question.data.selected = ctrl.question.data.placesLocality
            }
            ctrl.lastState = ctrl.state
            ctrl.state = ctrl.States.IDLE
          }, 0)
        },
        { once: true } // Ensure the event listener is removed after execution
      )
    }
  }
})()
